import React, { Component } from 'react';
import "./index.scss";

class index extends Component {
    render() {
        return (
            <div className="theChart">
                各餐厅收入占比 Restaurant Revenue %
                <div id="RestaurantIncome" style={{ height: 400, width: '100%' }}></div>
            </div>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/performanceAnalysis/analysisChart/RestaurantIncome.js